import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ReadonlyDropdownListComponent } from '@connect-services/client/components/readonly-dropdown-list/readonly-dropdown-list.component';
import { FieldInterventionContextLayerOption } from '@connect-services/client/services/field-intervention.service';
import { SelectComponent } from '@connect-services/src/lib/components/select/select.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

export enum ContextLayersDisplayModeEnum {
    EDITABLE = 'editable',
    READONLY = 'readonly',
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReadonlyDropdownListComponent, RessourcesModule, SelectComponent],
    selector: 'app-field-intervention-context-layers',
    templateUrl: './field-intervention-context-layers.component.html',
})
export class FieldInterventionContextLayersComponent {
    public readonly contextLayersOptions = input<FieldInterventionContextLayerOption[]>([]);
    public readonly contextLayersSelected = input<FieldInterventionContextLayerOption[]>([]);
    public readonly displayMode = input<ContextLayersDisplayModeEnum>(ContextLayersDisplayModeEnum.READONLY);
    public readonly selectionChange = output<string[]>();
    public readonly showEmptyReadonlyState = input<boolean>(true);

    protected readonly FieldInterventionContextLayersDisplayModeEnum = ContextLayersDisplayModeEnum;
}
